import { LightShadow, Vector2 } from "three";
import { SHADOW_SETTINGS } from "./settings";

export const applyShadowSettings = (shadow: LightShadow) => {
    if (SHADOW_SETTINGS) {
        shadow.mapSize = new Vector2(SHADOW_SETTINGS.mapSize, SHADOW_SETTINGS.mapSize);

        shadow.radius = SHADOW_SETTINGS.radius;
        shadow.blurSamples = SHADOW_SETTINGS.blurSamples;
    }
};
